import { render, staticRenderFns } from "./sys-content-header.vue?vue&type=template&id=7d47cc52&"
import script from "./sys-content-header.vue?vue&type=script&lang=ts&"
export * from "./sys-content-header.vue?vue&type=script&lang=ts&"
import style0 from "./sys-content-header.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports